import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/button';
import { restaurantInfo } from '../data/mock';

const LocationSection = () => {
  return (
    <section id="localizacao" className="section-padding bg-neutral-950 relative overflow-hidden" aria-labelledby="location-heading">
      {/* Background pattern */}
      <div className="absolute inset-0 oriental-pattern opacity-20" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <span className="text-amber-500 font-medium tracking-widest uppercase text-sm">
              Venha nos visitar
            </span>
            <h2 id="location-heading" className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 mb-6">
              Localização do Restaurante
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-700 to-amber-500 mb-8" />
            
            <p className="text-white/70 text-lg mb-8">
              Restaurante japonês localizado em Anápolis – GO. Venha nos visitar e experimente o melhor sushi da cidade.
            </p>

            {/* Address Card */}
            <address className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 mb-8 not-italic">
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-amber-700 rounded-xl flex items-center justify-center flex-shrink-0">
                  <MapPin className="text-white" size={28} aria-hidden="true" />
                </div>
                <div>
                  <h3 className="font-semibold text-white text-xl mb-2">Endereço</h3>
                  <p className="text-white/70 text-lg leading-relaxed">
                    {restaurantInfo.address.street}<br/>
                    {restaurantInfo.address.neighborhood}<br/>
                    {restaurantInfo.address.city} - {restaurantInfo.address.state}<br/>
                    CEP: {restaurantInfo.address.cep}
                  </p>
                </div>
              </div>
            </address>

            <Button
              size="lg"
              className="bg-amber-600 hover:bg-amber-700 text-white font-semibold px-8 py-6 text-lg btn-hover-lift flex items-center gap-3"
              onClick={() => window.open(restaurantInfo.googleMapsUrl, '_blank')}
              aria-label="Ver localização no Google Maps"
            >
              <Navigation size={20} aria-hidden="true" />
              Ver no Google Maps
            </Button>
          </div>

          {/* Map */}
          <div className="relative">
            <figure className="relative rounded-2xl overflow-hidden shadow-2xl">
              <div className="aspect-square bg-neutral-800 flex items-center justify-center">
                <iframe
                  title="Localização Japamix restaurante japonês Anápolis"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.5!2d-48.9534!3d-16.3281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTbCsDE5JzQxLjIiUyA0OMKwNTcnMTIuMiJX!5e0!3m2!1spt-BR!2sbr!4v1234567890"
                  className="w-full h-full min-h-[400px]"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
              
              {/* Overlay badge */}
              <figcaption className="absolute bottom-4 left-4 bg-white px-4 py-2 rounded-lg shadow-lg">
                <p className="font-semibold text-neutral-900 text-sm">JAPAMIX Anápolis</p>
                <p className="text-neutral-500 text-xs">Cidade Universitária, Anápolis - GO</p>
              </figcaption>
            </figure>
            
            {/* Decorative border */}
            <div className="absolute -top-4 -right-4 w-full h-full border-2 border-amber-600/30 rounded-2xl -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
